import { ref } from "vue";
import axios from "@/backend/axios/index.js";

export default function useModel(model, route) {
  const modelObject = ref({})
  const modelObjects = ref([])
  const loading = ref(false);
  const error = ref(null);

  const fetchModelObjects = async (params = {}) => {
    try {
      loading.value = true;
      const response = await axios.get(route, { params });
      const data = response.data && Array.isArray(response.data) ?
        response.data :
        response.data && response.data[pluralize(model)] || [];
      
      modelObjects.value = data;
    } catch (err) {
      error.value = err;
    } finally {
      loading.value = false;
    }
  };

  const fetchModelObject = async (id) => {
    try {
      loading.value = true;
      const response = await axios.get(`${route}/${id}`);
      modelObject.value = response.data;
    } catch (err) {
      error.value = err;
    } finally {
      loading.value = false;
    }
  };

  const createModelObject = async (data) => {
    try {
      loading.value = true;
      const response = await axios.post(route, data);
      modelObjects.value.push(response.data);
    } catch (err) {
      error.value = err;
    } finally {
      loading.value = false;
    }
  };

  const updateModelObject = async (id, data) => {
    try {
      loading.value = true;
      const response = await axios.put(`${route}/${id}`, data);
      const index = modelObjects.value.findIndex((p) => p.id === id);
      modelObjects.value[index] = response.data;
    } catch (err) {
      error.value = err;
    } finally {
      loading.value = false;
    }
  };

  const deleteModelObject = async (id) => {
    try {
      loading.value = true;
      await axios.delete(`${route}/${id}`);
      modelObjects.value = modelObjects.value.filter((p) => p.id !== id);
    } catch (err) {
      error.value = err;
    } finally {
      loading.value = false;
    }
  };

  const capitalizeFirstLetter = (val) => {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
  }

  const pluralize = (word) => {
    if (/[^aeiou]y$/i.test(word)) return word.replace(/y$/i, 'ies');
    
    if (/(s|x|z|ch|sh)$/i.test(word)) return word + 'es';
    
    return word + 's';
  };

  return {
    [`${pluralize(model)}`]: modelObjects,
    [model]: modelObject,
    [`isLoading${capitalizeFirstLetter(model)}`]: loading,
    [`${capitalizeFirstLetter(model)}Error`]: error,
    [`fetch${capitalizeFirstLetter(pluralize(model))}`]: fetchModelObjects,
    [`fetch${capitalizeFirstLetter(model)}`]: fetchModelObject,
    [`create${capitalizeFirstLetter(model)}`]: createModelObject,
    [`update${capitalizeFirstLetter(model)}`]: updateModelObject,
    [`delete${capitalizeFirstLetter(model)}`]: deleteModelObject,
  };
}